import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonRouterOutlet,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';


import '@ionic/react/css/core.css';

import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import './theme/variables.css';

import RestaurantLogin from './pages/auth/ui/AuthPage';
import MainTabs from './pages/main-tabs/ui/MainTabs';
import OrderedTable from './pages/ordered-table/ui/OrderedTable';
import AddFoods from './pages/add-foods/ui/AddFoods';
import { getData } from './core/preference';
import OrderChat from './pages/order-chat/Order-chat';
import { PrivateRoute } from './router/PrivateRoute';
setupIonicReact();

const App: React.FC = () => {
  const [token, setToken] = useState<any>(undefined);

  useEffect(() => {
    console.log("wewr",getData('token'))
    async function loadToken(){
      const res = await getData('token')
      setToken(res)
    }
    loadToken()
  }, [setToken]);
   return (
   <IonApp>
    <IonReactRouter>
      <IonRouterOutlet>
        <Route exact path="/auth">
          <RestaurantLogin />
        </Route>
        <PrivateRoute path="/tabs" component={MainTabs} />
        <PrivateRoute exact path="/ordered-table/:id" component={OrderedTable} />
        <PrivateRoute exact path="/order-chat/:orderId" component={OrderChat} />
        <PrivateRoute exact path="/add-foods" component={AddFoods} />
          {/* <Route exact path="/ordered-table/:id">
            <OrderedTable />
          </Route>
          <Route exact path="/add-foods">
            <AddFoods/>
          </Route>
          <Route exact path="/order-chat/:orderId">
            <OrderChat/>
          </Route> */}
          {/* <Route path="/tabs">
            <MainTabs />
          </Route> */}
       
        { token 
         ?<Redirect exact from="/" to="/tabs" />
         :<Redirect exact from="/" to="/auth" />}
       
      </IonRouterOutlet>
    </IonReactRouter>
  </IonApp>
   )

  };

export default App;
